module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAAXNSR0IArs4c6QAAAKdJREFUKFOFzqFKw3EUBeDvIDgYPoBPYPEFln2BIfgCJrvBvKhhac2yRYNVXF9YNppFTAZhiK78xg1/ENHttnvOx+UGWmvnuEYfC0ySPFbXTVprx3jC3s8CD7hI8lp5wTEuf6FufcdpkkXBJQb/wIpXOCn4hsMtsKplwW/s74AfBb/Q2wFnBZ9xtAXOcVbwBld/wBeMME3SCh7gFkN81uO4w32SdXdgA4RGOZGxVtnlAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/common/image1/shape.png
// module id = 7tbU
// module chunks = 28